var path = 'directives/linechart/linechart.html';
var html = "<div><nvd3 data=vm.processedGraphData options=vm.options></nvd3><chart-legend data=vm.processedChartLegendData count=\"{{ vm.count }}\"></chart-legend></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/directives/linechart/linechart.html
// module id = 185
// module chunks = 0